<i18n>
  {
    "fr": {
      "outward-info": "Aller",
      "return-info": "Retour",
      "duration": "Durée du voyage",
      "departure": "Départ",
      "arrival": "Arrivée",
      "terminal": "Terminal",
      "lands-on": "Atterrit le",
      "no-details": "Pas d'information sur le porteur",
      "stopover-details": "Changement d'avion à",
      "stopover-duration": "Durée de l'éscale",
      "stopover-airport-change": "Attention, changement d'aéroport de",
      "stopover-to": "à",
      "category-regular": "Vol régulier",
      "category-lowcost": "Vol lowcost",
      "category-ndc": "Vol régulier (NDC)",
      "ticket-remb": "Billets remboursable ou échangeable sous conditions",
      "ticket-no-remb": "Billets non remboursables",
      "info-supplier-class": "Information fournie par le fournisseur dans la langue de son choix.",
      "eq-type.ND2": "Aerospatiale (Nord) 262",
      "eq-type.CRV": "Aerospatiale (Sud Aviation) Se.210 Caravelle",
      "eq-type.NDC": "Aerospatiale SN.601 Corvette",
      "eq-type.AT4": "Aerospatiale/Alenia ATR 42-300",
      "eq-type.AT5": "Aerospatiale/Alenia ATR 42-500",
      "eq-type.ATR": "Aerospatiale/Alenia ATR 42-600",
      "eq-type.AT7": "Aerospatiale/Alenia ATR 72",
      "eq-type.AB3": "Airbus A300",
      "eq-type.AB6": "Airbus A300-600",
      "eq-type.ABB": "Airbus A300-600ST Super Transporter / Beluga",
      "eq-type.310": "Airbus A310",
      "eq-type.318": "Airbus A318",
      "eq-type.319": "Airbus A319",
      "eq-type.31N": "Airbus A319neo",
      "eq-type.320": "Airbus A320",
      "eq-type.32N": "Airbus A320neo",
      "eq-type.321": "Airbus A321",
      "eq-type.32Q": "Airbus A321neo",
      "eq-type.330": "Airbus A330",
      "eq-type.332": "Airbus A330-200",
      "eq-type.333": "Airbus A330-300",
      "eq-type.338": "Airbus A330-800neo",
      "eq-type.339": "Airbus A330-900neo",
      "eq-type.340": "Airbus A340",
      "eq-type.342": "Airbus A340-200",
      "eq-type.343": "Airbus A340-300",
      "eq-type.345": "Airbus A340-500",
      "eq-type.346": "Airbus A340-600",
      "eq-type.350": "Airbus A350",
      "eq-type.351": "Airbus A350-1000",
      "eq-type.359": "Airbus A350-900",
      "eq-type.380": "Airbus A380",
      "eq-type.388": "Airbus A380-800",
      "eq-type.ANF": "Antonov AN-12",
      "eq-type.A4F": "Antonov AN-124 Ruslan",
      "eq-type.A40": "Antonov AN-140",
      "eq-type.A81": "Antonov An-148",
      "eq-type.A58": "Antonov An-158",
      "eq-type.A25": "Antonov An-225 Mriya",
      "eq-type.AN4": "Antonov AN-24",
      "eq-type.A26": "Antonov AN-26",
      "eq-type.A28": "Antonov AN-28",
      "eq-type.A30": "Antonov AN-30",
      "eq-type.A32": "Antonov AN-32",
      "eq-type.AN7": "Antonov AN-72",
      "eq-type.AR1": "Avro RJ100",
      "eq-type.AR7": "Avro RJ70",
      "eq-type.AR8": "Avro RJ85",
      "eq-type.146": "BAe 146",
      "eq-type.141": "BAe 146-100",
      "eq-type.142": "BAe 146-200",
      "eq-type.143": "BAe 146-300",
      "eq-type.BEH": "Beechcraft 1900",
      "eq-type.BH2": "Bell 212",
      "eq-type.703": "Boeing 707",
      "eq-type.717": "Boeing 717",
      "eq-type.B72": "Boeing 720B",
      "eq-type.727": "Boeing 727",
      "eq-type.721": "Boeing 727-100",
      "eq-type.722": "Boeing 727-200",
      "eq-type.737": "Boeing 737",
      "eq-type.7MJ": "Boeing 737 MAX 10",
      "eq-type.7M7": "Boeing 737 MAX 7",
      "eq-type.7M8": "Boeing 737 MAX 8",
      "eq-type.7M9": "Boeing 737 MAX 9",
      "eq-type.732": "Boeing 737-200",
      "eq-type.733": "Boeing 737-300",
      "eq-type.734": "Boeing 737-400",
      "eq-type.735": "Boeing 737-500",
      "eq-type.736": "Boeing 737-600",
      "eq-type.73G": "Boeing 737-700",
      "eq-type.738": "Boeing 737-800",
      "eq-type.739": "Boeing 737-900",
      "eq-type.747": "Boeing 747",
      "eq-type.74B": "Boeing 747 LCF Dreamlifter",
      "eq-type.741": "Boeing 747-100",
      "eq-type.742": "Boeing 747-200",
      "eq-type.743": "Boeing 747-300",
      "eq-type.744": "Boeing 747-400",
      "eq-type.74J": "Boeing 747-400D",
      "eq-type.748": "Boeing 747-8",
      "eq-type.74L": "Boeing 747SP",
      "eq-type.74R": "Boeing 747SR",
      "eq-type.757": "Boeing 757",
      "eq-type.752": "Boeing 757-200",
      "eq-type.753": "Boeing 757-300",
      "eq-type.767": "Boeing 767",
      "eq-type.762": "Boeing 767-200",
      "eq-type.763": "Boeing 767-300",
      "eq-type.764": "Boeing 767-400",
      "eq-type.777": "Boeing 777",
      "eq-type.772": "Boeing 777-200",
      "eq-type.77L": "Boeing 777-200LR",
      "eq-type.773": "Boeing 777-300",
      "eq-type.77W": "Boeing 777-300ER",
      "eq-type.778": "Boeing 777-8",
      "eq-type.779": "Boeing 777-9",
      "eq-type.787": "Boeing 787",
      "eq-type.78J": "Boeing 787-10",
      "eq-type.788": "Boeing 787-8",
      "eq-type.789": "Boeing 787-9",
      "eq-type.CS1": "Bombardier CS100",
      "eq-type.CS3": "Bombardier CS300",
      "eq-type.CCX": "Bombardier Global Express",
      "eq-type.B11": "British Aerospace (BAC) One Eleven",
      "eq-type.H25": "British Aerospace 125 series / Hawker/Raytheon 700/800/800XP/850/900",
      "eq-type.H25": "British Aerospace 125-1000 series / Hawker/Raytheon 1000",
      "eq-type.ATP": "British Aerospace ATP",
      "eq-type.J31": "British Aerospace Jetstream 31",
      "eq-type.J32": "British Aerospace Jetstream 32",
      "eq-type.J41": "British Aerospace Jetstream 41",
      "eq-type.CCJ": "Canadair Challenger",
      "eq-type.CL4": "Canadair CL-44",
      "eq-type.CR1": "Canadair Regional Jet 100",
      "eq-type.CRK": "Canadair Regional Jet 1000",
      "eq-type.CR2": "Canadair Regional Jet 200",
      "eq-type.CR7": "Canadair Regional Jet 700",
      "eq-type.CR9": "Canadair Regional Jet 900",
      "eq-type.CN1": "Cessna 172",
      "eq-type.CN1": "Cessna 182 Skylane",
      "eq-type.CN1": "Cessna 208 Caravan",
      "eq-type.CN1": "Cessna 210 Centurion",
      "eq-type.CNJ": "Cessna Citation CJ3",
      "eq-type.CNJ": "Cessna Citation CJ4",
      "eq-type.CNJ": "Cessna Citation Excel",
      "eq-type.CNJ": "Cessna Citation I",
      "eq-type.CNJ": "Cessna Citation II",
      "eq-type.CNJ": "Cessna Citation Mustang",
      "eq-type.CNJ": "Cessna Citation Sovereign",
      "eq-type.CNJ": "Cessna Citation X",
      "eq-type.SSC": "Concorde",
      "eq-type.D20": "Dassault Falcon 2000",
      "eq-type.DF3": "Dassault Falcon 50",
      "eq-type.DF7": "Dassault Falcon 7X",
      "eq-type.DF9": "Dassault Falcon 900",
      "eq-type.DHP": "De Havilland Canada DHC-2 Beaver",
      "eq-type.DHR": "De Havilland Canada DHC-2 Turbo-Beaver",
      "eq-type.DHL": "De Havilland Canada DHC-3 Otter",
      "eq-type.DHC": "De Havilland Canada DHC-4 Caribou",
      "eq-type.DHT": "De Havilland Canada DHC-6 Twin Otter",
      "eq-type.DH7": "De Havilland Canada DHC-7 Dash 7",
      "eq-type.DH1": "De Havilland Canada DHC-8-100 Dash 8 / 8Q",
      "eq-type.DH2": "De Havilland Canada DHC-8-200 Dash 8 / 8Q",
      "eq-type.DH3": "De Havilland Canada DHC-8-300 Dash 8",
      "eq-type.DH4": "De Havilland Canada DHC-8-400 Dash 8Q",
      "eq-type.DHD": "De Havilland DH.104 Dove",
      "eq-type.DHH": "De Havilland DH.114 Heron",
      "eq-type.D10": "Douglas DC-10",
      "eq-type.D3F": "Douglas DC-3",
      "eq-type.D6F": "Douglas DC-6",
      "eq-type.D8T": "Douglas DC-8-50",
      "eq-type.D8L": "Douglas DC-8-62",
      "eq-type.D8Q": "Douglas DC-8-72",
      "eq-type.D91": "Douglas DC-9-10",
      "eq-type.D92": "Douglas DC-9-20",
      "eq-type.D93": "Douglas DC-9-30",
      "eq-type.D94": "Douglas DC-9-40",
      "eq-type.D95": "Douglas DC-9-50",
      "eq-type.E70": "Embraer 170",
      "eq-type.E75": "Embraer 175",
      "eq-type.E7W": "Embraer 175 (long wing)",
      "eq-type.E7W": "Embraer 175 (short wing)",
      "eq-type.E90": "Embraer 190",
      "eq-type.E95": "Embraer 195",
      "eq-type.290": "Embraer E190-E2",
      "eq-type.295": "Embraer E195-E2",
      "eq-type.EMB": "Embraer EMB 110 Bandeirante",
      "eq-type.EM2": "Embraer EMB 120 Brasilia",
      "eq-type.ER3": "Embraer Legacy 600",
      "eq-type.EP1": "Embraer Phenom 100",
      "eq-type.EP3": "Embraer Phenom 300",
      "eq-type.ER3": "Embraer RJ135",
      "eq-type.ERD": "Embraer RJ140",
      "eq-type.ER4": "Embraer RJ145",
      "eq-type.FRJ": "Fairchild Dornier 328JET",
      "eq-type.D28": "Fairchild Dornier Do.228",
      "eq-type.D38": "Fairchild Dornier Do.328",
      "eq-type.100": "Fokker 100",
      "eq-type.50": "Fokker 50",
      "eq-type.70": "Fokker 70",
      "eq-type.27": "Fokker F27 Friendship",
      "eq-type.21": "Fokker F28 Fellowship",
      "eq-type.GRS": "Gulfstream Aerospace G-159 Gulfstream I",
      "eq-type.GR3": "Gulfstream G280",
      "eq-type.GJ6": "Gulfstream G650",
      "eq-type.GJ4": "Gulfstream IV",
      "eq-type.GJ5": "Gulfstream V",
      "eq-type.ACP": "Gulfstream/Rockwell (Aero) Commander",
      "eq-type.ACT": "Gulfstream/Rockwell (Aero) Turbo Commander",
      "eq-type.YN2": "Harbin Yunshuji Y12",
      "eq-type.HS7": "Hawker Siddeley HS 748",
      "eq-type.I14": "Ilyushin IL114",
      "eq-type.IL8": "Ilyushin IL18",
      "eq-type.IL6": "Ilyushin IL62",
      "eq-type.IL7": "Ilyushin IL76",
      "eq-type.ILW": "Ilyushin IL86",
      "eq-type.I93": "Ilyushin IL96",
      "eq-type.LRJ": "Learjet 35",
      "eq-type.LRJ": "Learjet 60",
      "eq-type.L10": "Lockheed L-1011 Tristar",
      "eq-type.L49": "Lockheed L-1049 Super Constellation",
      "eq-type.LOH": "Lockheed L-182 / 282 / 382 (L-100) Hercules",
      "eq-type.LOE": "Lockheed L-188 Electra",
      "eq-type.M11": "McDonnell Douglas MD-11",
      "eq-type.M81": "McDonnell Douglas MD-81",
      "eq-type.M82": "McDonnell Douglas MD-82",
      "eq-type.M83": "McDonnell Douglas MD-83",
      "eq-type.M87": "McDonnell Douglas MD-87",
      "eq-type.M88": "McDonnell Douglas MD-88",
      "eq-type.M90": "McDonnell Douglas MD-90",
      "eq-type.YS1": "NAMC YS-11",
      "eq-type.PN6": "Partenavia P.68",
      "eq-type.BNT": "Pilatus Britten-Norman BN-2A Mk III Trislander",
      "eq-type.BNI": "Pilatus Britten-Norman BN-2A/B Islander",
      "eq-type.PL2": "Pilatus PC-12",
      "eq-type.PL6": "Pilatus PC-6 Turbo Porter",
      "eq-type.PA2": "Piper PA-31 Navajo",
      "eq-type.PAG": "Piper PA-46",
      "eq-type.S20": "Saab 2000",
      "eq-type.SF3": "Saab SF340A/B",
      "eq-type.SHB": "Shorts SC-5 Belfast",
      "eq-type.SHS": "Shorts SC-7 Skyvan",
      "eq-type.SH3": "Shorts SD.330",
      "eq-type.SH6": "Shorts SD.360",
      "eq-type.S58": "Sikorsky S-58T",
      "eq-type.S61": "Sikorsky S-61",
      "eq-type.S76": "Sikorsky S-76",
      "eq-type.S92": "Sikorsky S-92",
      "eq-type.SU9": "Sukhoi Superjet 100-95",
      "eq-type.TU3": "Tupolev Tu-134",
      "eq-type.TU5": "Tupolev Tu-154",
      "eq-type.T20": "Tupolev Tu-204",
      "eq-type.YK4": "Yakovlev Yak-40",
      "eq-type.YK2": "Yakovlev Yak-42",
      "eq-type.NOT DEFINED YET": "Non défini"
    },
    "en": {
      "outward-info": "Outward flight",
      "return-info": "Return flight",
      "duration": "Duration",
      "departure": "Departure",
      "arrival": "Arrival",
      "terminal": "Terminal",
      "lands-on": "Lands on",
      "no-details": "No details about the plane",
      "stopover-details": "Change of plane in",
      "stopover-duration": "Stopover duration",
      "stopover-airport-change": "Careful, change of airport in",
      "stopover-to": "to",
      "category-regular": "Regular flight",
      "category-lowcost": "Lowcost flight",
      "category-ndc": "Regular flight (NDC)",
      "ticket-remb": "Ticket refundable or exchangeable on conditions",
      "ticket-no-remb": "Non-refundable ticket",
      "info-supplier-class": "Information provided by the supplier in the language of their choice.",
      "eq-type.ND2": "Aerospatiale (Nord) 262",
      "eq-type.CRV": "Aerospatiale (Sud Aviation) Se.210 Caravelle",
      "eq-type.NDC": "Aerospatiale SN.601 Corvette",
      "eq-type.AT4": "Aerospatiale/Alenia ATR 42-300",
      "eq-type.AT5": "Aerospatiale/Alenia ATR 42-500",
      "eq-type.ATR": "Aerospatiale/Alenia ATR 42-600",
      "eq-type.AT7": "Aerospatiale/Alenia ATR 72",
      "eq-type.AB3": "Airbus A300",
      "eq-type.AB6": "Airbus A300-600",
      "eq-type.ABB": "Airbus A300-600ST Super Transporter / Beluga",
      "eq-type.310": "Airbus A310",
      "eq-type.318": "Airbus A318",
      "eq-type.319": "Airbus A319",
      "eq-type.31N": "Airbus A319neo",
      "eq-type.320": "Airbus A320",
      "eq-type.32N": "Airbus A320neo",
      "eq-type.321": "Airbus A321",
      "eq-type.32Q": "Airbus A321neo",
      "eq-type.330": "Airbus A330",
      "eq-type.332": "Airbus A330-200",
      "eq-type.333": "Airbus A330-300",
      "eq-type.338": "Airbus A330-800neo",
      "eq-type.339": "Airbus A330-900neo",
      "eq-type.340": "Airbus A340",
      "eq-type.342": "Airbus A340-200",
      "eq-type.343": "Airbus A340-300",
      "eq-type.345": "Airbus A340-500",
      "eq-type.346": "Airbus A340-600",
      "eq-type.350": "Airbus A350",
      "eq-type.351": "Airbus A350-1000",
      "eq-type.359": "Airbus A350-900",
      "eq-type.380": "Airbus A380",
      "eq-type.388": "Airbus A380-800",
      "eq-type.ANF": "Antonov AN-12",
      "eq-type.A4F": "Antonov AN-124 Ruslan",
      "eq-type.A40": "Antonov AN-140",
      "eq-type.A81": "Antonov An-148",
      "eq-type.A58": "Antonov An-158",
      "eq-type.A25": "Antonov An-225 Mriya",
      "eq-type.AN4": "Antonov AN-24",
      "eq-type.A26": "Antonov AN-26",
      "eq-type.A28": "Antonov AN-28",
      "eq-type.A30": "Antonov AN-30",
      "eq-type.A32": "Antonov AN-32",
      "eq-type.AN7": "Antonov AN-72",
      "eq-type.AR1": "Avro RJ100",
      "eq-type.AR7": "Avro RJ70",
      "eq-type.AR8": "Avro RJ85",
      "eq-type.146": "BAe 146",
      "eq-type.141": "BAe 146-100",
      "eq-type.142": "BAe 146-200",
      "eq-type.143": "BAe 146-300",
      "eq-type.BEH": "Beechcraft 1900",
      "eq-type.BH2": "Bell 212",
      "eq-type.703": "Boeing 707",
      "eq-type.717": "Boeing 717",
      "eq-type.B72": "Boeing 720B",
      "eq-type.727": "Boeing 727",
      "eq-type.721": "Boeing 727-100",
      "eq-type.722": "Boeing 727-200",
      "eq-type.737": "Boeing 737",
      "eq-type.7MJ": "Boeing 737 MAX 10",
      "eq-type.7M7": "Boeing 737 MAX 7",
      "eq-type.7M8": "Boeing 737 MAX 8",
      "eq-type.7M9": "Boeing 737 MAX 9",
      "eq-type.732": "Boeing 737-200",
      "eq-type.733": "Boeing 737-300",
      "eq-type.734": "Boeing 737-400",
      "eq-type.735": "Boeing 737-500",
      "eq-type.736": "Boeing 737-600",
      "eq-type.73G": "Boeing 737-700",
      "eq-type.738": "Boeing 737-800",
      "eq-type.739": "Boeing 737-900",
      "eq-type.747": "Boeing 747",
      "eq-type.74B": "Boeing 747 LCF Dreamlifter",
      "eq-type.741": "Boeing 747-100",
      "eq-type.742": "Boeing 747-200",
      "eq-type.743": "Boeing 747-300",
      "eq-type.744": "Boeing 747-400",
      "eq-type.74J": "Boeing 747-400D",
      "eq-type.748": "Boeing 747-8",
      "eq-type.74L": "Boeing 747SP",
      "eq-type.74R": "Boeing 747SR",
      "eq-type.757": "Boeing 757",
      "eq-type.752": "Boeing 757-200",
      "eq-type.753": "Boeing 757-300",
      "eq-type.767": "Boeing 767",
      "eq-type.762": "Boeing 767-200",
      "eq-type.763": "Boeing 767-300",
      "eq-type.764": "Boeing 767-400",
      "eq-type.777": "Boeing 777",
      "eq-type.772": "Boeing 777-200",
      "eq-type.77L": "Boeing 777-200LR",
      "eq-type.773": "Boeing 777-300",
      "eq-type.77W": "Boeing 777-300ER",
      "eq-type.778": "Boeing 777-8",
      "eq-type.779": "Boeing 777-9",
      "eq-type.787": "Boeing 787",
      "eq-type.78J": "Boeing 787-10",
      "eq-type.788": "Boeing 787-8",
      "eq-type.789": "Boeing 787-9",
      "eq-type.CS1": "Bombardier CS100",
      "eq-type.CS3": "Bombardier CS300",
      "eq-type.CCX": "Bombardier Global Express",
      "eq-type.B11": "British Aerospace (BAC) One Eleven",
      "eq-type.H25": "British Aerospace 125 series / Hawker/Raytheon 700/800/800XP/850/900",
      "eq-type.H25": "British Aerospace 125-1000 series / Hawker/Raytheon 1000",
      "eq-type.ATP": "British Aerospace ATP",
      "eq-type.J31": "British Aerospace Jetstream 31",
      "eq-type.J32": "British Aerospace Jetstream 32",
      "eq-type.J41": "British Aerospace Jetstream 41",
      "eq-type.CCJ": "Canadair Challenger",
      "eq-type.CL4": "Canadair CL-44",
      "eq-type.CR1": "Canadair Regional Jet 100",
      "eq-type.CRK": "Canadair Regional Jet 1000",
      "eq-type.CR2": "Canadair Regional Jet 200",
      "eq-type.CR7": "Canadair Regional Jet 700",
      "eq-type.CR9": "Canadair Regional Jet 900",
      "eq-type.CN1": "Cessna 172",
      "eq-type.CN1": "Cessna 182 Skylane",
      "eq-type.CN1": "Cessna 208 Caravan",
      "eq-type.CN1": "Cessna 210 Centurion",
      "eq-type.CNJ": "Cessna Citation CJ3",
      "eq-type.CNJ": "Cessna Citation CJ4",
      "eq-type.CNJ": "Cessna Citation Excel",
      "eq-type.CNJ": "Cessna Citation I",
      "eq-type.CNJ": "Cessna Citation II",
      "eq-type.CNJ": "Cessna Citation Mustang",
      "eq-type.CNJ": "Cessna Citation Sovereign",
      "eq-type.CNJ": "Cessna Citation X",
      "eq-type.SSC": "Concorde",
      "eq-type.D20": "Dassault Falcon 2000",
      "eq-type.DF3": "Dassault Falcon 50",
      "eq-type.DF7": "Dassault Falcon 7X",
      "eq-type.DF9": "Dassault Falcon 900",
      "eq-type.DHP": "De Havilland Canada DHC-2 Beaver",
      "eq-type.DHR": "De Havilland Canada DHC-2 Turbo-Beaver",
      "eq-type.DHL": "De Havilland Canada DHC-3 Otter",
      "eq-type.DHC": "De Havilland Canada DHC-4 Caribou",
      "eq-type.DHT": "De Havilland Canada DHC-6 Twin Otter",
      "eq-type.DH7": "De Havilland Canada DHC-7 Dash 7",
      "eq-type.DH1": "De Havilland Canada DHC-8-100 Dash 8 / 8Q",
      "eq-type.DH2": "De Havilland Canada DHC-8-200 Dash 8 / 8Q",
      "eq-type.DH3": "De Havilland Canada DHC-8-300 Dash 8",
      "eq-type.DH4": "De Havilland Canada DHC-8-400 Dash 8Q",
      "eq-type.DHD": "De Havilland DH.104 Dove",
      "eq-type.DHH": "De Havilland DH.114 Heron",
      "eq-type.D10": "Douglas DC-10",
      "eq-type.D3F": "Douglas DC-3",
      "eq-type.D6F": "Douglas DC-6",
      "eq-type.D8T": "Douglas DC-8-50",
      "eq-type.D8L": "Douglas DC-8-62",
      "eq-type.D8Q": "Douglas DC-8-72",
      "eq-type.D91": "Douglas DC-9-10",
      "eq-type.D92": "Douglas DC-9-20",
      "eq-type.D93": "Douglas DC-9-30",
      "eq-type.D94": "Douglas DC-9-40",
      "eq-type.D95": "Douglas DC-9-50",
      "eq-type.E70": "Embraer 170",
      "eq-type.E75": "Embraer 175",
      "eq-type.E7W": "Embraer 175 (long wing)",
      "eq-type.E7W": "Embraer 175 (short wing)",
      "eq-type.E90": "Embraer 190",
      "eq-type.E95": "Embraer 195",
      "eq-type.290": "Embraer E190-E2",
      "eq-type.295": "Embraer E195-E2",
      "eq-type.EMB": "Embraer EMB 110 Bandeirante",
      "eq-type.EM2": "Embraer EMB 120 Brasilia",
      "eq-type.ER3": "Embraer Legacy 600",
      "eq-type.EP1": "Embraer Phenom 100",
      "eq-type.EP3": "Embraer Phenom 300",
      "eq-type.ER3": "Embraer RJ135",
      "eq-type.ERD": "Embraer RJ140",
      "eq-type.ER4": "Embraer RJ145",
      "eq-type.FRJ": "Fairchild Dornier 328JET",
      "eq-type.D28": "Fairchild Dornier Do.228",
      "eq-type.D38": "Fairchild Dornier Do.328",
      "eq-type.100": "Fokker 100",
      "eq-type.50": "Fokker 50",
      "eq-type.70": "Fokker 70",
      "eq-type.27": "Fokker F27 Friendship",
      "eq-type.21": "Fokker F28 Fellowship",
      "eq-type.GRS": "Gulfstream Aerospace G-159 Gulfstream I",
      "eq-type.GR3": "Gulfstream G280",
      "eq-type.GJ6": "Gulfstream G650",
      "eq-type.GJ4": "Gulfstream IV",
      "eq-type.GJ5": "Gulfstream V",
      "eq-type.ACP": "Gulfstream/Rockwell (Aero) Commander",
      "eq-type.ACT": "Gulfstream/Rockwell (Aero) Turbo Commander",
      "eq-type.YN2": "Harbin Yunshuji Y12",
      "eq-type.HS7": "Hawker Siddeley HS 748",
      "eq-type.I14": "Ilyushin IL114",
      "eq-type.IL8": "Ilyushin IL18",
      "eq-type.IL6": "Ilyushin IL62",
      "eq-type.IL7": "Ilyushin IL76",
      "eq-type.ILW": "Ilyushin IL86",
      "eq-type.I93": "Ilyushin IL96",
      "eq-type.LRJ": "Learjet 35",
      "eq-type.LRJ": "Learjet 60",
      "eq-type.L10": "Lockheed L-1011 Tristar",
      "eq-type.L49": "Lockheed L-1049 Super Constellation",
      "eq-type.LOH": "Lockheed L-182 / 282 / 382 (L-100) Hercules",
      "eq-type.LOE": "Lockheed L-188 Electra",
      "eq-type.M11": "McDonnell Douglas MD-11",
      "eq-type.M81": "McDonnell Douglas MD-81",
      "eq-type.M82": "McDonnell Douglas MD-82",
      "eq-type.M83": "McDonnell Douglas MD-83",
      "eq-type.M87": "McDonnell Douglas MD-87",
      "eq-type.M88": "McDonnell Douglas MD-88",
      "eq-type.M90": "McDonnell Douglas MD-90",
      "eq-type.YS1": "NAMC YS-11",
      "eq-type.PN6": "Partenavia P.68",
      "eq-type.BNT": "Pilatus Britten-Norman BN-2A Mk III Trislander",
      "eq-type.BNI": "Pilatus Britten-Norman BN-2A/B Islander",
      "eq-type.PL2": "Pilatus PC-12",
      "eq-type.PL6": "Pilatus PC-6 Turbo Porter",
      "eq-type.PA2": "Piper PA-31 Navajo",
      "eq-type.PAG": "Piper PA-46",
      "eq-type.S20": "Saab 2000",
      "eq-type.SF3": "Saab SF340A/B",
      "eq-type.SHB": "Shorts SC-5 Belfast",
      "eq-type.SHS": "Shorts SC-7 Skyvan",
      "eq-type.SH3": "Shorts SD.330",
      "eq-type.SH6": "Shorts SD.360",
      "eq-type.S58": "Sikorsky S-58T",
      "eq-type.S61": "Sikorsky S-61",
      "eq-type.S76": "Sikorsky S-76",
      "eq-type.S92": "Sikorsky S-92",
      "eq-type.SU9": "Sukhoi Superjet 100-95",
      "eq-type.TU3": "Tupolev Tu-134",
      "eq-type.TU5": "Tupolev Tu-154",
      "eq-type.T20": "Tupolev Tu-204",
      "eq-type.YK4": "Yakovlev Yak-40",
      "eq-type.YK2": "Yakovlev Yak-42",
      "eq-type.NOT DEFINED YET": "Not defined"
    }
  }
</i18n>

<template>
  <div class="text-center">
    <v-card
      flat
      color="primaryLight"
      class="pl-0"
    >
      <v-card-text>
        <div
          v-for="(segment, index) in flight.segments"
          :key="index"
        >
          <v-row
            no-gutters
            class="my-2"
          >
            <v-col
              cols="3"
              class="px-4"
            >
              <p class="my-0 subtitle-2">
                {{ formatDate(segment.begin) }}
              </p>
              <p
                v-if="arrivalIsNotTheSameDay(segment)"
                class="caption red--text"
              >
                {{ $t('lands-on') }} {{ formatDate(segment.end) }}
              </p>
            </v-col>
            <v-col cols="9">
              <v-row no-gutters>
                <v-col class="text-left">
                  <v-icon
                    color="primary"
                    small
                    class="pr-2"
                  >
                    mdi-clock-outline
                  </v-icon>
                  <b>{{ formatHour(segment.begin) }} - {{ formatHour(segment.end) }}</b>
                </v-col>
                <v-spacer />
                <v-col>
                  <p
                    class="text-caption"
                  >
                    <span v-if="['AF','LH','BA','IB','SN','LX','OS','EW'].indexOf(segment.marketing_carrier) !== -1">
                      <span v-if="segment.category === 'LowCost'">{{ $t('category-ndc') }}</span>
                      <span v-else>{{ $t('category-'+segment.category.toLowerCase()) }}</span>
                    </span>
                    <span v-else>{{ $t('category-'+segment.category.toLowerCase()) }}</span>
                  </p>
                </v-col>
                <v-col
                  cols="4"
                  class="text-right"
                >
                  <p>
                    <b>{{ formatDuration(segment.duration) }}</b>
                  </p>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col class="text-left">
                  <v-icon
                    color="primary"
                    small
                    class="mr-2"
                  >
                    mdi-airplane-takeoff
                  </v-icon>
                  <span>{{ segment.from_place.name }} (<b>{{ segment.from_place.code }}</b>)</span>
                  <span v-if="segment.from_place.terminal">
                    <span> - </span>
                    <span>{{ $t('terminal') }} {{ segment.from_place.terminal }}</span>
                  </span>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col class="text-left">
                  <v-icon
                    color="primary"
                    small
                    class="mr-2"
                  >
                    mdi-airplane-landing
                  </v-icon>
                  <span>{{ segment.to_place.name }} (<b>{{ segment.to_place.code }}</b>)</span>
                  <span v-if="segment.to_place.terminal">
                    <span> - </span>
                    <span>{{ $t('terminal') }} {{ segment.to_place.terminal }}</span>
                  </span>
                </v-col>
              </v-row>
              <v-row
                class="my-2"
                no-gutters
              >
                <v-col
                  cols="6"
                  class="text-left"
                >
                  <v-icon
                    color="primary"
                    small
                    class="mr-2"
                  >
                    mdi-credit-card-outline
                  </v-icon>
                  <span>{{ segment.marketing_carrier_name }} (<b>{{ segment.marketing_carrier }} {{ segment.flight_number }}</b>)</span>
                </v-col>
                <v-col
                  cols="6"
                  class="text-left"
                >
                  <v-icon
                    color="primary"
                    class="mr-2"
                    small
                  >
                    mdi-airplane
                  </v-icon>
                  <span>{{ displayEqType(segment.air_equip_type) }}</span>
                </v-col>
              </v-row>
              <v-row
                v-if="segment.supplier_class_description"
                no-gutters
                class="my-2"
              >
                <v-col
                  class="text-left"
                >
                  <v-tooltip top>
                    <template #activator="{on, attrs}">
                      <v-icon
                        v-bind="attrs"
                        color="primary"
                        class="mr-2"
                        small
                        v-on="on"
                      >
                        mdi-information
                      </v-icon>
                    </template>
                    <span>{{ $t('info-supplier-class') }}</span>
                  </v-tooltip>
                  <span>{{ segment.supplier_class_description }}</span>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row
            v-if="index < (flight.segments.length - 1)"
            no-gutters
          >
            <v-col>
              <v-card
                flat
                color="primary"
                class="pa-0 stopover-card white--text"
              >
                <v-row>
                  <v-col
                    cols="10"
                    class="text-left"
                  >
                    <template v-if="!stopoverAirportChange(flight.segments[index], flight.segments[index + 1])">
                      <span class="pl-2">{{ $t('stopover-details') }}</span>&nbsp;
                      <span class="subtitle-2">{{ flight.segments[index].to_place.name }} ({{ flight.segments[index].to_place.code }})</span>
                    </template>
                    <template v-if="stopoverAirportChange(flight.segments[index], flight.segments[index + 1])">
                      <v-row no-gutters>
                        <v-col cols="1">
                          <v-icon
                            color="red"
                            class="warning-icon"
                          >
                            mdi-alert
                          </v-icon>
                        </v-col>
                        <v-col>
                          <p class="font-weight-bold my-0 white--text">
                            {{ displayAirportChange(flight.segments[index], flight.segments[index + 1]) }}
                          </p>
                        </v-col>
                      </v-row>
                    </template>
                  </v-col>

                  <v-col class="mr-2 text-right">
                    <p class="my-0">
                      <b>{{ stopoverDuration(flight.segments[index], flight.segments[index + 1]) }}</b>
                    </p>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'FlightItineraryDetails',
  props: {
    flight: {
      type: Object,
      required: true
    },
    refundable: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    /**
     * Format duration to 00H00m format
     * @param durationInMinutes {number}
     * @return {string}
     */
    formatDuration (durationInMinutes) {
      const momentDuration = this.$moment.duration(durationInMinutes, 'minutes')
      const hours = Math.floor(momentDuration.asHours())
      let minutes = (momentDuration.minutes())
      if (minutes < 10) {
        const m = minutes.toString()
        minutes = `0${m}`
      }
      return `${hours}H${minutes}m`
    },
    /**
     * Format a datetime string to HH:mm format
     * @param datetime {string}
     * @return {*}
     */
    formatHour (datetime) {
      const momentHour = this.$moment(datetime)
      return momentHour.format('HH:mm')
    },
    /**
     * Format a datetime string to dddd DD MMMM format
     * @param datetime {string}
     * @return {*}
     */
    formatDate (datetime) {
      const formatDate = this.$moment(datetime)
      return formatDate.format('dddd DD MMMM')
    },
    /**
     * Take a segment as an input and check if the begining of the segment is the same day as the end
     * @param segment {Object}
     * @return {boolean}
     */
    arrivalIsNotTheSameDay (segment) {
      const departure = this.$moment(segment.begin)
      const arrival = this.$moment(segment.end)
      return departure.format('DD') !== arrival.format('DD')
    },
    /**
     * Take 2 different segment as an input and calculate the stopover duration between those 2
     * by soustracting the first segment ending datetime to the second segment begining datetime
     * @param segment1 {Object}
     * @param segment2 {Object}
     * @return {string}
     */
    stopoverDuration (segment1, segment2) {
      const dateTime1 = this.$moment(segment1.end)
      const dateTime2 = this.$moment(segment2.begin)
      const diff = dateTime2.diff(dateTime1, 'minutes')
      return this.formatDuration(diff)
    },
    /**
     * Take 2 segment as an input and verify if there is an airport change between them (during the stopover)
     * @param segment1 {Object}
     * @param segment2 {Object}
     * @return {boolean}
     */
    stopoverAirportChange (segment1, segment2) {
      return segment1.to_place.code !== segment2.from_place.code
    },
    /**
     * Calculate the amount of luggage a traveller can take for the itinerary
     * @param luggage {Object}
     * @return {number}
     */
    displayLuggage (luggage) {
      let quantity = 0
      if (luggage) {
        for (const obj of luggage) {
          quantity += obj.quantity
        }
      }
      return quantity
    },
    /**
     * Try to display the model of the plane by searching his iata code in the i18n json
     * @param eqType {string}
     * @return {string}
     */
    displayEqType (eqType) {
      if (eqType === 'N/A') {
        return this.$i18n.t('no-details')
      }
      let localeMessages = this.$i18n.t(`eq-type.${eqType.toUpperCase()}`)
      if (localeMessages.startsWith('eq-type.')) {
        localeMessages = eqType
      }
      return localeMessages
    },
    /**
     * Return a sentence based on the departure / arrival airport of the 2 segments
     * @param segment1 {Object}
     * @param segment2 {Object}
     * @return {string}
     */
    displayAirportChange (segment1, segment2) {
      const begin = this.$i18n.t('stopover-airport-change')
      const to = this.$i18n.t('stopover-to')
      const departureAirport = `${segment1.to_place.name} (${segment1.to_place.code})`
      const arrivalAirport = `${segment2.from_place.name} (${segment2.from_place.code})`
      return `${begin} ${departureAirport} ${to} ${arrivalAirport}`
    }
  }
}
</script>

<style scoped>
  ::v-deep .v-card__text {
    color: #003d58 !important;
  }

  .warning-icon {
    top: calc(50% - 12px);
    left: calc(50% - 12px);
  }
</style>
